export class TomApiError extends Error {
	status?: number;
	key?: string;

	constructor(message: string, status?: number, key?: string) {
		super(message);
		this.name = 'TomApiError';
		this.status = status;
		this.key = key;
	}
}
